<template>
  <div
    :id="id"
    :data-backdrop="backdrop"
    class="modal fade"
    tabindex="-1"
    role="dialog">
    <div
      :class="{'modal-lg': large, 'modal-sm': small}"
      class="modal-dialog"
      role="document">
      <div class="modal-content">
        <slot/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalContainer',

  props: {
    id: { required: true },
    large: { default: false, type: Boolean },
    small: { default: false, type: Boolean },
    static: { default: false, type: Boolean }
  },

  computed: {
    backdrop () {
      if (this.static) {
        return 'static'
      }

      return true
    }
  }
}
</script>
